import { Component, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { saleElement } from '../../interfaces/saleElement';

@Component({
  selector: 'app-sales-table',
  templateUrl: './sales-table.component.html',
  styleUrls: ['./sales-table.component.css']
})
export class SalesTableComponent implements OnChanges {
  @Input() loading: boolean = true;
  @Input() ELEMENT_DATA: saleElement[] = [];

  displayedColumns: string[] = ['fecha_venta', 'rut', 'nombre_cliente', 'plan'];
  dataSource = new MatTableDataSource<saleElement>(this.ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor() { }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes) {
    //console.log(changes, 'changes-ngOnChanges');
    if (changes.ELEMENT_DATA) {
      this.dataSource = new MatTableDataSource<saleElement>(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
    }

  }


}
